import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { transitions } from '../../themes/theme-keys/transitions.esm.js';
import capitalize from '../../utils/capitalize.esm.js';

var classes = {
  badge: function badge() {
    var transitions$1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : transitions;
    return {
      transition: transitions$1.create('transform', {
        easing: transitions$1.easing.easeInOut,
        duration: transitions$1.duration.enteringScreen
      })
    };
  },
  /* Styles applied to the root element if `type="dot"`. */
  dot: {
    borderRadius: '100%',
    height: '.5em',
    minWidth: '.5em',
    padding: 0
  },
  anchorOriginTopRightSquare: {
    top: 0,
    right: 0,
    transform: 'scale(1) translate(50%, -50%)',
    transformOrigin: '100% 0%'
  },
  /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangular"`. */
  anchorOriginTopRightRectangular: {
    top: '0',
    right: 'auto',
    left: '55%',
    '&.invisible': {
      transform: 'scale(0) translate(50%, -50%)',
      border: 'unset'
    }
  },
  /* Styles applied to the root element if `anchorOrigin={{ 'center', 'right' }} overlap="rectangular"`. */
  anchorOriginCenterRightRectangular: {
    top: 'auto',
    bottom: 'auto',
    right: 'auto',
    left: '65%',
    '&.invisible': {
      transform: 'scale(0) translate(50%, 0)',
      border: 'unset'
    }
  },
  /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangular"`. */
  anchorOriginBottomRightRectangular: {
    bottom: '0',
    right: 'auto',
    left: '55%',
    '&.invisible': {
      transform: 'scale(0) translate(50%, 50%)',
      border: 'unset'
    }
  },
  /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangular"`. */
  anchorOriginTopLeftRectangular: {
    top: '0',
    right: '55%',
    left: 'auto',
    '&.invisible': {
      transform: 'scale(0) translate(-50%, -50%)',
      border: 'unset'
    }
  },
  /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangular"`. */
  anchorOriginBottomLeftRectangular: {
    bottom: '0',
    right: '55%',
    left: 'auto',
    '&.invisible': {
      transform: 'scale(0) translate(-50%, 50%)',
      border: 'unset'
    }
  },
  /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circular"`. */
  anchorOriginTopRightCircular: {
    top: '14%',
    right: '14%',
    transform: 'scale(1) translate(50%, -50%)',
    transformOrigin: '100% 0%',
    '&.invisible': {
      transform: 'scale(0) translate(50%, -50%)',
      border: 'unset'
    }
  },
  /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circular"`. */
  anchorOriginBottomRightCircular: {
    bottom: '14%',
    right: '14%',
    transform: 'scale(1) translate(50%, 50%)',
    transformOrigin: '100% 100%',
    '&.invisible': {
      transform: 'scale(0) translate(50%, 50%)',
      border: 'unset'
    }
  },
  /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circular"`. */
  anchorOriginTopLeftCircular: {
    top: '14%',
    left: '14%',
    transform: 'scale(1) translate(-50%, -50%)',
    transformOrigin: '0% 0%',
    '&.invisible': {
      transform: 'scale(0) translate(-50%, -50%)',
      border: 'unset'
    }
  },
  /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circular"`. */
  anchorOriginBottomLeftCircular: {
    bottom: '14%',
    left: '14%',
    transform: 'scale(1) translate(-50%, 50%)',
    transformOrigin: '0% 100%',
    '&.invisible': {
      transform: 'scale(0) translate(-50%, 50%)',
      border: 'unset'
    }
  },
  /* Pseudo-class to the badge `span` element if `invisible={true}`. */
  invisible: function invisible() {
    var transitions$1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : transitions;
    return {
      transition: transitions$1.create('transform', {
        easing: transitions$1.easing.easeInOut,
        duration: transitions$1.duration.leavingScreen
      })
    };
  }
};
var badges = {
  "default": function _default(theme, props) {
    var _theme$transitions = theme.transitions,
      transitions$1 = _theme$transitions === void 0 ? transitions : _theme$transitions;
    var anchorOrigin = props.anchorOrigin,
      _props$overlap = props.overlap,
      overlap = _props$overlap === void 0 ? 'rectangular' : _props$overlap;
    return _objectSpread2(_objectSpread2(_objectSpread2({}, classes.badge(transitions$1)), {}, {
      '&.dot': classes.dot
    }, anchorOrigin ? classes["anchorOrigin".concat(capitalize(anchorOrigin.vertical)).concat(capitalize(anchorOrigin.horizontal)).concat(capitalize(overlap))] : {}), classes.invisible(transitions$1));
  },
  white: function white(theme, props) {
    var _theme$transitions2 = theme.transitions,
      transitions$1 = _theme$transitions2 === void 0 ? transitions : _theme$transitions2;
    var anchorOrigin = props.anchorOrigin,
      _props$overlap2 = props.overlap,
      overlap = _props$overlap2 === void 0 ? 'rectangular' : _props$overlap2;
    return _objectSpread2(_objectSpread2(_objectSpread2({}, classes.badge(transitions$1)), {}, {
      color: 'primary',
      bg: 'white',
      '&.dot': classes.dot
    }, anchorOrigin ? classes["anchorOrigin".concat(capitalize(anchorOrigin.vertical)).concat(capitalize(anchorOrigin.horizontal)).concat(capitalize(overlap))] : {}), classes.invisible(transitions$1));
  },
  primary: function primary(theme, props) {
    var _theme$transitions3 = theme.transitions,
      transitions$1 = _theme$transitions3 === void 0 ? transitions : _theme$transitions3;
    var anchorOrigin = props.anchorOrigin,
      _props$overlap3 = props.overlap,
      overlap = _props$overlap3 === void 0 ? 'rectangular' : _props$overlap3;
    return _objectSpread2(_objectSpread2(_objectSpread2({}, classes.badge(transitions$1)), {}, {
      color: 'white',
      bg: 'primary',
      border: 'white',
      '&.dot': classes.dot
    }, anchorOrigin ? classes["anchorOrigin".concat(capitalize(anchorOrigin.vertical)).concat(capitalize(anchorOrigin.horizontal)).concat(capitalize(overlap))] : {}), classes.invisible(transitions$1));
  },
  accent: function accent(theme, props) {
    var _theme$transitions4 = theme.transitions,
      transitions$1 = _theme$transitions4 === void 0 ? transitions : _theme$transitions4;
    var anchorOrigin = props.anchorOrigin,
      _props$overlap4 = props.overlap,
      overlap = _props$overlap4 === void 0 ? 'rectangular' : _props$overlap4;
    return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes.badge(transitions$1)), {}, {
      color: 'white',
      bg: 'accent',
      border: 'white'
    }, classes.invisible(transitions$1)), {}, {
      '&.dot': classes.dot
    }, anchorOrigin ? classes["anchorOrigin".concat(capitalize(anchorOrigin.vertical)).concat(capitalize(anchorOrigin.horizontal)).concat(capitalize(overlap))] : {}), classes.invisible(transitions$1));
  }
};

export { badges };
//# sourceMappingURL=variants.esm.js.map
